module.exports = __webpack_public_path__ + "92e98a1fd6f983e6d8b439291897f274.fbx";